// The small pieces the rank's screens share (RankDialog, RankChange, the player card).
import React from "react";
import { CALIBRATION_GAMES, rankInfo, rankLabel } from "../../lib/ranks";
import { t } from "../../lib/i18n";

export const tierName = (info) => t(`rank.tiers.${info.tier}`);
export const labelOf = (info) => (info.calibrating ? t("rank.calibrating") : rankLabel(info, tierName(info)));
export const fmt = (n) => String(Math.round(n || 0));

// How far along the division the player is, from its first point to the next step.
export function RankBar({ info, className = "" }) {
  return (
    <div className={`h-1.5 overflow-hidden rounded-full bg-white/10 ${className}`}>
      <div
        className="h-full rounded-full bg-gradient-to-r from-amber-600 via-amber-400 to-amber-200"
        style={{ width: `${Math.round(Math.max(0.04, Math.min(1, info.progress)) * 100)}%` }}
      />
    </div>
  );
}

export function Stat({ label, value, accent }) {
  return (
    <div className="rounded-xl border border-white/5 bg-slate-950/50 px-2 py-1.5 text-center">
      <div className={`text-base leading-tight tabular-nums ${accent || "text-white"}`}>{value}</div>
      <div className="mt-0.5 text-[10px] leading-tight text-slate-400">{label}</div>
    </div>
  );
}

// « 60 PR avant Or II », or « Le plus haut rang ».
export function nextLabel(info) {
  if (info.next == null) return t("rank.top");
  const next = rankInfo({ rp: info.next, games: CALIBRATION_GAMES });
  return t("rank.toNext", { n: fmt(info.next - info.rp), rank: rankLabel(next, tierName(next)) });
}
